import { FC, ReactElement, useState, useEffect } from 'react'
import styled from 'styled-components'
import ReactPlayer from 'react-player'

import { device } from '../../breakpoints'
import useImageFallback from 'hooks/useImageFallback'
import useGetElementWidth from 'hooks/useGetElementWidth'

interface ShowProps {
  youtube_id: string
}

const TVShows: FC<ShowProps> = ({ youtube_id }): ReactElement => {
  const [elementRef, width] = useGetElementWidth()
  const [showYoutube, setShowYoutube] = useState(false)
  const height = (width * 9) / 16

  useEffect(() => {
    let img = new Image()
    img.src = 'http://img.youtube.com/vi/' + youtube_id + '/mqdefault.jpg'
    img.onload = () => {
      setShowYoutube(img.width > 120)
    }
  }, [youtube_id])

  // const imageUrl = useImageFallback(
  //   `https://img.youtube.com/vi/${youtube_id}/hqdefault.jpg`,
  //   require('./imageFallback.jpg')
  // )
  return (
    <Container>
      {/* <ImageContainer $imageUrl={imageUrl} /> */}
      <ContentWidth ref={elementRef}>
        {showYoutube && (
          <ReactPlayer
            url={`https://www.youtube.com/watch?v=${youtube_id}`}
            width={width}
            height={height}
            controls
          />
        )}
      </ContentWidth>
    </Container>
  )
}

const Container = styled.div`
  margin-top: 1em;
`
const ContentWidth = styled.div`
  margin: 0 auto;
  max-width: 960px;
`

const ImageContainer = styled.div.attrs<{ $imageUrl: string }>(
  ({ $imageUrl }) => ({
    style: {
      backgroundImage: `url(${$imageUrl})`,
    },
  })
)<{ $imageUrl: string }>`
  height: 0;
  overflow: hidden;
  padding-top: 56.25%;
  position: relative;
  margin-bottom: 1em;
  background-size: cover;
  background-position: center;
`

export default TVShows
